// src/pages/ResumePage.js
import React from 'react';
import './ResumePage.css';

export default function ResumePage() {
  const downloadHTML = () => {
    const html = document.documentElement.outerHTML;
    const blob = new Blob([html], {type: 'text/html'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Raul_Correa_Resume.html';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="resume-page">
      <div className="resume" id="resume-root">
        <div className="header">
          <div>
            <div className="name">Raul Correa</div>
            <div className="contact">
              <div>(760) 349-6770</div>
              <div>raulco1@yahoo.com</div>
              <div><a href="https://raulco.org" target="_blank" rel="noopener">raulco.org</a></div>
              <div><a href="https://linkedin.com/in/raulco" target="_blank" rel="noopener">linkedin.com/in/raulco</a></div>
            </div>
          </div>
          <div className="controls" aria-hidden="true">
            <button className="btn" onClick={() => window.print()}>Download PDF / Print</button>
            <button className="btn ghost" onClick={downloadHTML}>Download HTML</button>
          </div>
        </div>

        <div className="section summary">
          <p><strong>Summary</strong><br/>
          Analytical and results-driven <strong>Financial and Data Analyst</strong> with proven success supporting financial, operational, and analytical processes across multi-department organizations. Skilled in conducting in-depth data analysis, forecasting, and performance reporting to optimize costs and support data-informed decision-making. Adept at leveraging <strong>SQL, Python, Power BI, and Excel (VBA)</strong> to design automated dashboards, enhance data integrity, and streamline reporting workflows.</p>
        </div>

        <div className="section">
          <h3>Core Competencies</h3>
          <div className="competencies">
            <div className="comp-row"><p><strong>Budgeting & Forecasting:</strong> Revenue & Expense Modeling • Financial Modeling • Variance Analysis • Forecast Accuracy • Budget Consolidation</p></div>
            <div className="comp-row"><p><strong>Reporting & Analytics:</strong> SQL Reporting • Excel (Advanced Formulas, VBA) • Power BI Dashboards • Data Visualization • Executive Reporting</p></div>
            <div className="comp-row"><p><strong>Process Improvement:</strong> Automation • Workflow Optimization • Data Integrity • Documentation • Continuous Improvement</p></div>
            <div className="comp-row"><p><strong>Cross-Functional Collaboration:</strong> Stakeholder Support • KPI Reporting • Strategic Business Insights • Data-Driven Decision Support</p></div>
          </div>
        </div>

        <div className="section experience">
          <h3>Experience</h3>

          <div className="job">
            <div className="job-title">Financial Planning and Analysis (FP&A) Analyst</div>
            <div className="job-meta">Twenty-Nine Palms Band of Mission Indians • Jun 2023 – Aug 2025</div>
            <ul className="bullets">
              <li>Delivered financial and operational analyses for 100+ departments across multiple entities, improving forecasting accuracy and supporting strategic decisions.</li>
              <li>Automated SQL- and Excel-based reporting tools, reducing reporting cycle times by 30%+ and increasing transparency for leadership teams.</li>
              <li>Analyzed labor costs, KPIs, and revenue trends to identify inefficiencies and recommend data-backed process improvements.</li>
              <li>Prepared executive reports and KPI summaries to improve budget monitoring and variance analysis.</li>
              <li>Supported financial system migrations with data mapping, validation, and integrity checks.</li>
            </ul>
          </div>

          <div className="job">
            <div className="job-title">Database Specialist</div>
            <div className="job-meta">Twenty-Nine Palms Band of Mission Indians • Nov 2022 – Mar 2023</div>
            <ul className="bullets">
              <li>Designed automated Excel and SQL-based tools that enhanced purchasing and financial reporting accuracy.</li>
              <li>Improved database management practices to ensure reliable reporting across business units.</li>
              <li>Collaborated with Finance, Procurement, and Operations to deliver timely and accurate reports.</li>
            </ul>
          </div>

          <div className="job">
            <div className="job-title">CAD Drafter / Technical Support</div>
            <div className="job-meta">Kincaid Industries • May 2021 – Sep 2022</div>
            <ul className="bullets">
              <li>Improved documentation and data-handling procedures, enhancing reporting accuracy and operational efficiency.</li>
              <li>Provided technical support and training to field and office teams to maintain data integrity.</li>
            </ul>
          </div>

          <div className="job">
            <div className="job-title">Programming Instructor</div>
            <div className="job-meta">theCoderSchool North San Diego • Feb 2020 – Jun 2021</div>
            <ul className="bullets">
              <li>Taught coding fundamentals (Python, HTML, CSS, JavaScript) and mentored small groups on data logic and automation concepts.</li>
            </ul>
          </div>

          <div className="job">
            <div className="job-title">Product Engineer Intern</div>
            <div className="job-meta">Quantum Design • Jun 2018 – Sep 2018</div>
            <ul className="bullets">
              <li>Automated data collection workflows, reducing manual processing by 8+ hours per week and building visualization tools for engineering troubleshooting.</li>
            </ul>
          </div>
        </div>

        <div className="section row">
          <div className="col">
            <h3>Key Projects</h3>
            <ul className="bullets">
              <li><strong>Market Trends Analytics Report:</strong> Built a Python analytics pipeline using public APIs (CPI, GDP, unemployment) to generate economic trend forecasts and Power BI visualizations. (02/2023 – 05/2023)</li>
              <li><strong>Housing Market Forecast Tool:</strong> Developed a Python-based model analyzing Coachella Valley real estate trends to visualize price fluctuations and demand insights. (10/2020 – 01/2021)</li>
            </ul>
          </div>

          <div className="col">
            <h3>Technical Skills</h3>
            <div className="skills" aria-hidden="false">
              <div className="skill-pill">SQL</div>
              <div className="skill-pill">Python</div>
              <div className="skill-pill">Power BI</div>
              <div className="skill-pill">Excel (VBA)</div>
              <div className="skill-pill">PivotTables</div>
              <div className="skill-pill">Power Query</div>
              <div className="skill-pill">DAX</div>
              <div className="skill-pill">Financial Modeling</div>
              <div className="skill-pill">Forecasting</div>
              <div className="skill-pill">KPI Reporting</div>
            </div>
          </div>
        </div>

        <div className="section education">
          <h3>Education</h3>
          <div><strong>Bachelor of Science in Physics</strong> — University of California, San Diego • Graduated Dec 2019</div>
          <div style={{marginTop: '6px', color: 'var(--muted)', fontSize: '13px'}}>Relevant Coursework: Computational Statistics, Mathematical & Computational Physics, Managing Diverse Teams</div>
        </div>
      </div>
    </div>
  );
}
